import { unauthenticatedMiddleware } from '@/middleware/UnauthenticatedMiddleware.js'
import Login from '@/views/Login.vue'
import Auth from '@/views/unauthenticated/Auth.vue'
import Contractor from '@/views/unauthenticated/Contractor.vue'
import Index from '@/views/unauthenticated/Index.vue'
import User from '@/views/unauthenticated/User.vue'
import VerificationIndex from '@/views/unauthenticated/verification/Index.vue'
import Methods from '@/views/unauthenticated/verification/Methods.vue'
import Add from '@/views/unauthenticated/verification/Methods/Add.vue'
import Confirm from '@/views/unauthenticated/verification/Methods/Confirm.vue'
import Confirmed from '@/views/unauthenticated/verification/Methods/Confirmed.vue'
import Optional from '@/views/unauthenticated/verification/Optional.vue'
import Sent from '@/views/unauthenticated/verification/Sent.vue'
import Welcome from '@/views/unauthenticated/Welcome.vue'

export const unauthenticatedRoutes = [
  {
    path: '/auth',
    component: Auth,
    children: [
      {
        path: ':token',
        name: 'auth.index',
        component: Index,
      },
      {
        path: 'welcome',
        name: 'auth.welcome',
        component: Welcome,
        beforeEnter: [unauthenticatedMiddleware],
      },
      {
        path: 'contractor',
        name: 'auth.contractor',
        component: Contractor,
        beforeEnter: [unauthenticatedMiddleware],
      },
      {
        path: 'user',
        name: 'auth.user',
        component: User,
        beforeEnter: [unauthenticatedMiddleware],
      },
      {
        path: 'verification',
        name: 'auth.verification',
        beforeEnter: [unauthenticatedMiddleware],
        children: [
          {
            path: '',
            name: 'auth.verification.index',
            component: VerificationIndex,
          },
          {
            path: 'optional',
            name: 'auth.verification.optional',
            component: Optional,
          },
          {
            path: 'methods',
            name: 'auth.verification.methods',
            component: Methods,
          },
          {
            path: 'methods/add',
            name: 'auth.verification.methods.add',
            component: Add,
          },
          {
            path: 'methods/:userPendingVerificationMethod/confirm',
            name: 'auth.verification.methods.confirm',
            component: Confirm,
          },
          {
            path: 'methods/:userPendingVerificationMethod/confirmed',
            name: 'auth.verification.methods.confirmed',
            component: Confirmed,
          },
          {
            path: 'sent',
            name: 'auth.verification.sent',
            component: Sent,
          },
        ],
      },
    ],
  },
  {
    path: '/login/:loginToken',
    name: 'login',
    component: Login,
  },
]
